import {
  CompositeFilterDescriptor,
  SortDescriptor
} from '@progress/kendo-data-query';
import { ModelUser } from '@module-user/models/model-user';
import { ModelClaimsDocuments } from '@module-claims/models/claims-document.interface';
import { ClaimFileDownloadRequest } from '@module-claims/models/claim-file-download.interface';
import { CustomerServiceType } from '@module-customer/enums/customer-service-type.enum';
import { BatchStatisticsLevel } from '@module-claims/enums/batch-statistics-level.enum';
import {
  ClaimsSummaryParams,
  ClaimsSummaryStatisticsParams,
  ClaimsGroupListParamsV2,
  ClaimBatchUpdateParamsV2,
  AuditClaimFileSummaryParams
} from '@module-claims/models/claims-http.interface';
import { IClaimsFileUploadLogParams } from '@module-claims/models/claim-upload.interface';
import { IClaimAuditStatusUpdateParams } from '@module-claims/models/claim.interface';

export class ClearCustomersList {
  static readonly type = '[ Claims ] Clear customers list';
}

export class GetCustomersList {
  static readonly type = '[ Claims ] Get customers list';

  constructor(public filters?: CompositeFilterDescriptor) {}
}

export class GetPBMList {
  static readonly type = '[ Claims ] Get PBM list';
}

export class GetClaimFileLOBList {
  static readonly type = '[ Claims ] Get claim file LOB list';
}

export class ClearClaimsUploadList {
  static readonly type = '[ Claims ] Clear claims upload list';
}

export class GetClaimsUploadList {
  static readonly type = '[ Claims ] Get claims upload list';

  constructor(public params: IClaimsFileUploadLogParams) {}
}

export class DownloadClaimFile {
  static readonly type = '[ Claims ] Download claim file';

  constructor(public params: ClaimFileDownloadRequest) {}
}

export class ReverseClaimUpload {
  static readonly type = '[ Claims ] Reverse claims upload';

  constructor(public claimUploadId: string) {}
}

export class ClearClaimsGroupsList {
  static readonly type = '[ Claims ] Clear Claims Groups List';
}

export class GetClaimsManagementDataV2 {
  static readonly type = '[ Claims ] Get Claims Management Data V2';

  constructor(
    public params: ClaimsGroupListParamsV2,
    public queryClaimsList: boolean
  ) {}
}

export class ClearClaimsList {
  static readonly type = '[ Claims ] Clear Claims List';
}

export class GetClaimsList {
  static readonly type = '[ Claims ] Get Claims List';

  constructor(
    public userId: string,
    public fileId: string,
    public skip = 0,
    public take = 10,
    public entityId?: string,
    public statusCode?: string,
    public sort?: SortDescriptor[],
    public serviceType?: CustomerServiceType
  ) {}
}

export class ClearClaimsCustomersList {
  static readonly type = '[ Claims ] Clear Claims Customers List';
}

export class GetClaimsCustomersList {
  static readonly type = '[ Claims ] Get Claims Customers List';

  constructor(
    public skip = 0,
    public take = 10,
    public user?: ModelUser,
    public sort?: SortDescriptor[],
    public filter?: CompositeFilterDescriptor
  ) {}
}

export class ClearClaimDetails {
  static readonly type = '[ Claims ] Clear Claim Details';
}

export class GetClaimDetails {
  static readonly type = '[ Claims ] Get Claim Details';

  constructor(public userId: string, public claimIntakeId: string) {}
}

export class UpdateClaim {
  static readonly type = '[ Claims ] Update Claim';

  constructor(public params: ClaimBatchUpdateParamsV2) {}
}

export class Update340BAuditSingleClaim {
  static readonly type = '[ Claims ] Update 340B Audit Single Claim';
  constructor(public params: IClaimAuditStatusUpdateParams) {}
}

export class Complete340BAuditManualReviewSingleClaim {
  static readonly type =
    '[ Claims ] Complete 340B Audit Manual Review Single Claim';
  constructor(public intakeId: string) {}
}

export class uploadClaim {
  static readonly type = '[ Claims ] upload Claim';

  constructor(
    public code: string,
    public claimsDocuments: ModelClaimsDocuments
  ) {}
}

export class GetClaimsSummary {
  static readonly type = '[ Claims ] Get Claims Summary';

  constructor(public params: ClaimsSummaryParams) {}
}

export class GetClaimsSummaryBatchStatistics {
  static readonly type = '[ Claims ] Get Claims Summary Batch Statistics';

  constructor(public params: ClaimsSummaryStatisticsParams) {}
}

export class ClearClaimsSummaryBatchStatistics {
  static readonly type = '[ Claims ] Clear Claims Summary Batch Statistics';

  constructor(public level?: BatchStatisticsLevel) {}
}

export class DeleteClaimFile {
  static readonly type = '[ Claims ] Delete Claim File';

  constructor(public fileId: string) {}
}

export class GetClaimFileStatus {
  static readonly type = '[ Claims ] Get Claim File Status';

  constructor(public fileId: string) {}
}

export class GetAuditClaimFiles {
  static readonly type = '[ Claims ] Get Audit Claim Files';

  constructor(public params: AuditClaimFileSummaryParams) {}
}

export class GetReviewedAuditClaimFiles {
  static readonly type = '[ Claims ] Get Reviewed Audit Claim Files';

  constructor(public customerId: string) {}
}

export class GetAuditClaimTotals {
  static readonly type = '[ Claims ] Get Audit Claim Totals';

  constructor(
    public customerId: string,
    public filters?: { [key: string]: string | number }
  ) {}
}

export class GetAuditReportingStatusTotals {
  static readonly type = '[ Claims ] Get Audit Reporting Status Totals';

  constructor(
    public customerId: string,
    public filters?: { [key: string]: string | number }
  ) {}
}

export class GetAuditReportingResolutionTrends {
  static readonly type = '[ Claims ] Get Audit Reporting Resolution Trends';

  constructor(
    public customerId: string,
    public filters?: { [key: string]: string | number }
  ) {}
}

export class GetAuditReportingTop340B {
  static readonly type = '[ Claims ] Get Audit Reporting Top 340B';

  constructor(
    public customerId: string,
    public filters?: { [key: string]: string | number }
  ) {}
}

export class GetAuditReportingTopNot340B {
  static readonly type = '[ Claims ] Get Audit Reporting Top Not 340B';

  constructor(
    public customerId: string,
    public filters?: { [key: string]: string | number }
  ) {}
}

export class GetAuditReportingTopDisputed {
  static readonly type = '[ Claims ] Get Audit Reporting Top Disputed';

  constructor(
    public customerId: string,
    public filters?: { [key: string]: string | number }
  ) {}
}

export class GetAuditReportingTopDisputeResolution {
  static readonly type =
    '[ Claims ] Get Audit Reporting Top Dispute Resolution';

  constructor(
    public customerId: string,
    public filters?: { [key: string]: string | number }
  ) {}
}

export class ClearAuditReporting {
  static readonly type = '[ Claims ] Clear Audit Reporting';
}
